import { BaseResolver } from "./BaseResolver";
import { IAttentionDayService } from "./attentiondays/IAttentionDayService";
import { IEmployeeAbsenceService } from "./absences/IEmployeeAbsenceService";
import { IEmployeeService } from "./employees/IEmployeeService";
import { INavigator } from "./navigation/INavigator";
import { IRequestLanguageChange } from "./translations/IRequestLanguageChange";
import { IRequestNotify } from "./notifications/IRequestNotify";
import { IRequestPermission } from "./users/IRequestPermission";
import { IRequestTranslation } from "./translations/IRequestTranslation";
import { IAuthenticationService } from "./authentication/IAuthenticationService";
import { EventNames } from "./events/Events";
import { IEventSubscription } from "./events/IEventHandler";
import { IEventProvider } from "./events/IEventProvider";
import { IHandleExceptions } from "./app/IHandleExceptions";
import { IRequestVersionInfo } from "./appVersion/IRequestVersionInfo";
import { IRequestAlert } from "./notifications/IRequestAlert";
import { IRequestMenuItems } from "./appMenu/IRequestMenuItems";
import { ICanBlockUI } from "./notifications/ICanBlockUI";
import { IEmployeeGroupService } from "./employeeGroups/IEmployeeGroupService";

// tslint:disable:naming-convention
class AppDomain extends BaseResolver {
    get IAuthenticationService() { return this.resolve<IAuthenticationService>("IAuthenticationService"); }
    get IHandleExceptions() { return this.resolve<IHandleExceptions>("IHandleExceptions"); }
    get INavigator() { return this.resolve<INavigator>("INavigator"); }
    get IEventProvider() { return this.resolve<IEventProvider>("IEventProvider"); }
    get IRequestVersionInfo() { return this.resolve<IRequestVersionInfo>("IRequestVersionInfo"); }
    get IRequestPermission() { return this.resolve<IRequestPermission>("IRequestPermission"); }
    get IRequestAlert() { return this.resolve<IRequestAlert>("IRequestAlert"); }
    get IRequestLanguageChange() { return this.resolve<IRequestLanguageChange>("IRequestLanguageChange"); }
    get IRequestTranslation() { return this.resolve<IRequestTranslation>("IRequestTranslation"); }
    get IRequestNotify() { return this.resolve<IRequestNotify>("IRequestNotify"); }
    get IRequestMenuItems() { return this.resolve<IRequestMenuItems>("IRequestMenuItems"); }
    get ICanBlockUI() { return this.resolve<ICanBlockUI>("ICanBlockUI"); }
    get IEmployeeAbsenceService() { return this.resolve<IEmployeeAbsenceService>("IEmployeeAbsenceService"); }
    get IEmployeeService() { return this.resolve<IEmployeeService>("IEmployeeService"); }
    get IAttentionDayService() { return this.resolve<IAttentionDayService>("IAttentionDayService"); }
    get IEmployeeGroupService() { return this.resolve<IEmployeeGroupService>("IEmployeeGroupService"); }
}

export const appDomain = new AppDomain();

export const translate = (translationKey: string, obj?: {}): string => appDomain.IRequestTranslation.translate(translationKey, obj);

export const navigateTo = (url: string, params?: any): void => appDomain.INavigator.navigateTo(url, params);

export const appEmit = (eventName: EventNames, data?: any) => appDomain.IEventProvider.emit(eventName, data);
export const appSubscribe = <T>(eventName: string, fn: (data: T) => void): IEventSubscription => appDomain.IEventProvider.subscribe(eventName, fn);
